/* Página principal: presenta el proyecto y autentica la entrada del usuario */

//*react- recursos

//*componentes-utiles
  import VentanaObjErrorAPI from "../../componentes/generaVentana/VentanaObjErrorAPI";

//*clases 
  import './autenticar.css';

//*datos

//*archivos & Componentes (imagenes y elementos necesarios para la rutina)
  import Presentacion  from "./Presentacion";
  import Autenticacion from "./Autenticacion";
  

//*api's (servicios y store)
  import authenticateStore from "../../api/recursos/authenticate/authenticate.store"; 

//*store's

//*funciones

//*interfaces 

//*componente
  export default function Autenticar(){
    //*api store
      const { objErrorAuthenticateStore } =  
          authenticateStore((state:any) =>( { 
            objErrorAuthenticateStore: state.objErrorAuthenticateStore
        }));

    //*store's
    
    //*data 

    //*constantes y variables

    //*usestate

    //*useEffect

    //* interface (parametros de entrada)

    //*funciones & código de inicio
      
     if (window.location.href.indexOf('Autenticar')>-1 && sessionStorage.usuario!=undefined) {
        localStorage.removeItem("usuario");
        sessionStorage.removeItem("usuario");
        sessionStorage.clear();
        localStorage.clear();
     }
     window.onbeforeunload = function() { //lo generá cuando se descarga
          if (window.location.href.indexOf('Autenticar')==-1 && window.location.href!="")
            localStorage.clear();
     };

    //*vista
      return (
          <>
            <div className='scrollHidden'>
              <div className="left-half">  <Presentacion /></div>
              <div className="right-half "> <Autenticacion /></div>
            </div> 
            
            { objErrorAuthenticateStore.hasError
              &&  <VentanaObjErrorAPI recurso="authenticate"  objError={objErrorAuthenticateStore} /> 
            }
          </>
      );    
  }

